import script from "./AutoTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoTooltip.vue?vue&type=script&setup=true&lang=js"

import "./AutoTooltip.vue?vue&type=style&index=0&id=72c979b8&scoped=true&lang=css"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72c979b8"]])

export default __exports__